export default __webpack_public_path__ + "static/media/logo.38b84902.webp";